// extracted by mini-css-extract-plugin
export default {"header":"_8cgb5vLZRRnDN+Tvcfgr-A==","description":"_4k-RM+o3HeeScmpTe2tfzw==","divider":"_9dikxIxY6TvRA+79DkZMbg==","mb-24":"F9e2dkGBKQT5um4rhRg3Hw=="};